import moment from 'moment';
import { z } from 'zod';

const restoredState = z.object({
  expiration: z.number(),
  data: z.record(z.string(), z.any())
});
export function tryRestoreStateFromStorage<T extends Record<string, any>>(
  key: string,
  initialState: T
): T {
  try {
    const serialisedState = localStorage.getItem(key);
    if (serialisedState === null) return initialState;
    const saveData = JSON.parse(serialisedState);

    restoredState.parse(saveData);

    if (
      moment()
        .startOf('day')
        .subtract(2, 'day')
        .isAfter(moment.unix(saveData.expiration))
    ) {
      throw new Error(`The state has expired. ${JSON.stringify(saveData)}`);
    }
    return saveData.data as T;
  } catch (error) {
    localStorage.removeItem(key);
    console.log({
      error: error,
      status: 'Restoring initial state'
    });
    return initialState;
  }
}

export function saveStateToStorage(key: string, data: any) {
  try {
    const saveData = {
      expiration: moment().unix(),
      data
    };

    localStorage.setItem(key, JSON.stringify(saveData));
  } catch (error) {
    console.log(`[saveStateToStorage] Error when persisting state ${error}`);
  }
}

export function cleanPagedQuestionnaireStorage(storageKey: string) {
  localStorage.removeItem(storageKey);
  localStorage.removeItem(`${storageKey}-pagination`);
}
